import Layout from '@/components/Layout'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 在当前页面时候再次点击当前页面，会有警告！
// 原因：在路由中添加了相同的路由。
// 解决： 重写路由的push方法
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

function load (view) {
  // return () => import(`@/views/${view}.vue`)
  return resolve => require([`@/views/${view}.vue`], resolve)
}

export default new Router({
  routes: [
    { path: '/login', component: load('Login'), hidden: true },
    {
      path: '/',
      component: Layout,
      hidden: true,
      redirect: '/home',
      children: [{ path: '/home', name: '首页', component: load('index'), icon: 'home' }]
    },
    {
      path: '/p',
      component: Layout,
      name: '',
      icon: 'el-icon-message',
      children: [{ path: '/p', name: '游戏管理', component: load('Product/index'), icon: 'fab fa-product-hunt' }]
    },
    {
      path: '/c',
      component: Layout,
      name: '渠道接入',
      subMenu: true,
      icon: 'fa-plug',
      children: [
        { path: '/c/cl', name: '渠道列表', component: load('Channel/index'), icon: 'fa-plug' },
        { path: '/c/detail', name: '渠道详情', component: load('Channel/ChannelDialog'), hidden: true },
        { path: '/pl', name: '平台规划', component: load('Platform/index'), icon: 'fa-sliders-h' },
        { path: '/ct', name: '渠道类型', component: load('ChannelType/index'), icon: 'fa-tags' },
        { path: '/l', name: 'Visitor逻辑', component: load('Logic/index'), icon: 'fa-microchip' },
        { path: '/holiday', name: '节假日', component: load('Holiday/index'), icon: 'fa-calendar-alt' },
        { path: '/menu', name: '卸载菜单', component: load('Menu/index'), icon: 'fa-list-ul' },
        { path: '/n', name: '同步参数', component: load('Node/index'), icon: 'fa-sync' },
        { path: '/nacos', name: '重载NACOS', component: load('Node/index'), icon: 'fa-rotate' }
      ]
    },
    {
      path: '/advert',
      component: Layout,
      name: '广告变现',
      subMenu: true,
      icon: 'fab fa-adversal',
      children: [
        { path: '/advert/app', name: '广告应用', component: load('Advert/App'), icon: 'fab fa-adversal' },
        { path: '/advert/channel', name: '广告渠道', component: load('Advert/Channel'), icon: 'fa-yen-sign' }
      ]
    },
    {
      path: '/config',
      component: Layout,
      name: '环境配置',
      subMenu: true,
      icon: 'fa-gear',
      children: [
        { path: '/area', name: '网关域名', component: load('Area/index'), icon: 'fa-network-wired' },
        { path: '/ufo/group', name: 'UFO分组', component: load('UfoGroup/index'), icon: 'fa-layer-group' },
        { path: '/pkg', name: '证书配置', component: load('Pkg/index'), icon: 'fa-certificate' }
      ]
    },
    {
      path: '/ufw',
      component: Layout,
      name: 'UFW',
      subMenu: true,
      icon: 'fa-shield-heart',
      children: [
        { path: '/ufw', name: '节点内存', component: load('Ufw/index'), icon: 'fa-memory' },
        { path: '/ufw/black', name: '黑名单', component: load('Ufw/blackUfw'), icon: 'fa-solid fa-passport' },
        { path: '/ufw/white', name: '白名单', component: load('Ufw/whiteUfw'), icon: 'fa-passport' }
      ]
    },
    {
      path: '/company',
      component: Layout,
      name: '公司主体',
      subMenu: true,
      icon: 'fa-building-columns',
      children: [
        { path: '/company', name: '公司管理', component: load('Company/Company'), icon: 'fa-building' },
        { path: '/organize', name: '组织管理', component: load('Company/Organize'), icon: 'fa-building-columns' }
      ]
    },
    {
      path: '/mch',
      component: Layout,
      name: '商户配置',
      subMenu: true,
      icon: 'fa-m',
      children: [
        { path: '/mch/group', name: '商户组', component: load('Mch/Group'), icon: 'fa-layer-group' },
        { path: '/mch/wx', name: '微信商户', component: load('Mch/Wx/index'), icon: 'fa-comments' },
        { path: '/mch/ali', name: '支付宝商户', component: load('Mch/Ali/index'), icon: 'fab fa-alipay' },
        { path: '/mch/apple', name: 'Apple应用', component: load('Mch/Apple/index'), icon: 'fa-apple-whole' }
      ]
    },
    {
      path: '/xs',
      component: Layout,
      name: '登录支付',
      subMenu: true,
      icon: 'fa-x',
      children: [
        { path: '/xs/args/game', name: 'XS游戏', component: load('Xs/Args/Game'), icon: 'fa-gamepad' },
        { path: '/xs/args/channel', name: 'XS渠道', component: load('Xs/Args/Channel'), icon: 'fa-link' },
        { path: '/xs/args/logic', name: 'XS逻辑', component: load('Xs/Logic/index'), icon: 'fa-cog' },
        { path: '/xs/telecom/auth', name: '电信认证', component: load('Xs/TelecomAuth/index'), icon: 'fa-mobile-alt' },
        { path: '/xs/args/pay', name: '支付Agrs', component: load('Xs/ArgsPay/index'), icon: 'fa-coins' }
      ]
    },
    {
      path: '/ext',
      component: Layout,
      name: '扩展配置',
      subMenu: true,
      icon: 'fa-e',
      children: [
        { path: '/ext/config/game', name: 'Ext游戏', component: load('Ext/GameConfig'), icon: 'fa-puzzle-piece' },
        { path: '/ext/config/channel', name: 'Ext渠道', component: load('Ext/ChannelConfig'), icon: 'fa-link' },
        { path: '/ext/config/template', name: 'Ext模版', component: load('Ext/ConfigTemplate'), icon: 'fa-cubes' }
      ]
    },
    {
      path: '/other',
      component: Layout,
      name: '其他',
      subMenu: true,
      icon: 'fa-folder',
      children: [
        { path: '/wiki/app', name: '应用分配', component: load('Wiki/WikiApp'), icon: 'fa-cube' },
        { path: '/wiki/vpc', name: 'VPC规划', component: load('Wiki/WikiVpc'), icon: 'fa-network-wired' }
      ]
    },
    // Always leave this last one
    { path: '*', component: load('404'), hidden: true }
  ]
})
